import PropTypes from 'prop-types'
import React from 'react'
import clone from 'lodash/clone'
import reject from 'lodash/reject'
import matches from 'lodash/matches'
import GiftCardsList from '../GiftCardsList'
import PaymentList from '../PaymentList'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'

export default function SelectedPayments(props) {
  const giftCards = reject(clone(props.giftCards), matches({ inUse: false }))

  return (
    <div id={props.id}>
      <section className="list">
        {giftCards.length > 0 ? (
          <GiftCardsList
            id={buildChildId('giftcards', props.id)}
            giftCards={giftCards}
            renderActions={props.renderPaymentActions}
          />
        ) : null}
        {props.payments.length > 0 ? (
          <PaymentList
            id={buildChildId('payments', props.id)}
            initialIndex={props.initialIndex}
            paymentSystems={props.paymentSystems}
            installmentOptions={props.installmentOptions}
            payments={props.payments}
            onSelectInstallment={props.onSelectInstallment}
            renderActions={props.renderPaymentActions}
          />
        ) : null}
      </section>
    </div>
  )
}

SelectedPayments.defaultProps = {
  initialIndex: 0,
}

SelectedPayments.propTypes = {
  id: PropTypes.string,
  initialIndex: PropTypes.number,
  giftCards: PropTypes.array,
  installmentOptions: PropTypes.array,
  paymentSystems: PropTypes.array,
  payments: PropTypes.array,
  renderPaymentActions: PropTypes.func,
  onSelectInstallment: PropTypes.func,
}
